export const quickResultsReducerKey = 'quickResultsReducerKey';

export const quickResultsSetIsLoadingReducerType = 'quickResultsSetIsLoadingReducerType';
export const quickResultsSetAllResultsReducerType = 'quickResultsSetAllResultsReducerType';
export const quickResultsSetPreviewResultsReducerType = 'quickResultsSetPreviewResultsReducerType';

export const quickResultsSetStructureReducerType = 'quickResultsSetStructureReducerType';
export const quickResultsSetStructurePreviewReducerType = 'quickResultsSetStructurePreviewReducerType';

export const quickResultsSetQueryReducerType = 'quickResultsSetQueryReducerType';
export const quickResultsSetIsQueryEnabledReducerType = 'quickResultsSetIsQueryEnabledReducerType';
export const quickResultsSetIsBioactivityVisualizationButtonEnabledPreviewReducerType =
  'quickResultsSetIsBioactivityVisualizationButtonEnabledPreviewReducerType';

export const quickResultsSetIsResultsPreviewReadyReducerType = 'quickResultsSetIsResultsPreviewReadyReducerType';
export const quickResultsShouldTrackSearchResultsReducerType = 'quickResultsShouldTrackSearchResultsReducerType';
export const quickResultsSetRequestIdReducerType = 'quickResultsSetRequestIdReducerType';
export const quickResultsSetSearchIdReducerType = 'quickResultsSetSearchIdReducerType';

export const quickResultsResetStateReducerType = 'quickResultsResetStateReducerType';
